

import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { Presentation, PresentationState } from "../../../dev/gameflow/controller/Presentation";
import { InitData } from '../../server/data/BaseModel';
import { RoadRage } from '../../RoadRage';
import { stickyFS } from '../../server/data/IData';
import { RoadRageEngineManager } from '../../reel/RoadRageEngineManager';
import { FsLeftBox } from '../../background/FsLeftBox';
import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import { RoadRageEngineController } from '../../reel/RoadRageEngineController';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { StartPresentation } from '../general/StartPresentation';
import { PosterManager } from '../../independent/poster/PosterManager';

export class FSRestore extends Presentation {

    private amount:number = 0;
    private gameAreaSize:number = 0;

    private cartActivated:string[] = [];
    private activeValues:number[][] = [];
    private stickyWilds:stickyFS[] = [];
    private isBelowStake: boolean = false;
    private isNormal: boolean = false;

    private initD:InitData;

    private ammS:number = 0;

    private isTotalWin:boolean = false;

    private forceSize: boolean = false;

    private currentSize: number = 0;

    checkForActivation(data:InitData): boolean { 
        return data.isRestoreState && !data.nextModeSetup && data.isFreeSpin;
    }

    // This badboy will define if it is a restore.
    setInitData(data:InitData):void{
        if(data.isRestoreState && !data.nextModeSetup && data.isFreeSpin){
            this.PresentationState.set(PresentationState.ACTIVATED);
            this.gameAreaSize = data.Reel.worldSize;
            this.isNormal = data.mode === GameMode.NORMAL;
            if(data.fsInfo.fsCars){
                this.cartActivated = Object.keys(data.fsInfo.fsCars);
                this.cartActivated.forEach(v => this.activeValues.push(data.fsInfo.fsCars[v]));
            }
            this.initD = data;
            this.isBelowStake = data.Win.isWinBelowStake!()
            this.stickyWilds = data.Reel.stickWildPos;
            this.ammS = data.Reel.amountOfScattersLanded;
            this.forceSize = data.nextModeSetup;
            this.currentSize = data.raw.fsInfo.fsGameSize ? data.raw.fsInfo.fsGameSize : 3;
            this.amount = data.Win.totalWin;
            this.isTotalWin = data.Win.totalWin != data.Win.singleWin;
            data.Reel.saveLastStickes(false);
        }
    }

    preStart():void{
        RoadRageEngineManager.preferedLayoutSize = this.gameAreaSize;

        RoadRage.backgroundElements.fadeInCloud();

        if(!this.forceSize){
            RoadRage.reelManager.forcedRestoreSizeChange(this.gameAreaSize);
            RoadRage.backgroundElements.forceBackground(this.gameAreaSize);
            RoadRageEngineManager.wantsToSwitch = false;
        }else{
            RoadRage.reelManager.forcedRestoreSizeChange(this.currentSize);
            RoadRage.backgroundElements.forceBackground(this.currentSize);
        }

        RoadRageEngineManager.onBeforeSpinStart();
        RoadRageEngineManager.RAll((rc: RoadRageEngineController) => rc.createStart({ start:() => this.addExtraForStart ? this.addExtraForStart(rc) : undefined }) );

        SoundManager.playSoundEffect(SoundConfig.REELS_SPINNING, Number.MAX_SAFE_INTEGER,1)
        RoadRage.reelManager.applyMask(true);

        if( this.currentSize != this.ammS)
            PosterManager.instance.restoreShow(this.currentSize === 3, this.ammS === 4)

        if(this.stickyWilds.length)
            this.stickyWilds.forEach(sWild => RoadRageEngineManager.getReel(sWild.reel).setSticky([sWild.row]));

        StartPresentation.restoreStarted = true;
        RoadRageEngineManager.RAll(reel => {
            if(!reel.isActive) return;
            reel.startReel();
        });

        SoundManager.ChangeToLoop([introSoundVal(this.cartActivated.length-1)]);
        SoundManager.startAmbient();
        RoadRage.backgroundElements.speedUpCloud();

        function introSoundVal(val: number): string {
            return SoundConfig.FS_MUSIC_INTRO[val];
        }

        SlotGame.keypadPlugin.setWin(this.amount, this.isTotalWin, this.isBelowStake);
    }

    showCarBoxes(): void {
        this.cartActivated.forEach((c,i) => {
            this.timeline.add(RoadRage.bgOverlay.enableBox(c,true,false), 0)
            RoadRage.bgOverlay.fetchBoxBytype(c).multValue = this.activeValues[i][0];
            RoadRage.bgOverlay.fetchBoxBytype(c).splitValue = this.activeValues[i][1];
        });
        
        this.stickyWilds.forEach(v => {
            RoadRageEngineManager.getReel(v.reel).getSymbol(v.row)?.changeState({ state: "Sticky", forceState: true, sym: v.type === "WC12" ? "WC4" : v.type, duration:0.15 })
            RoadRageEngineManager.getReel(v.reel).getSymbol(v.row)?.applyMultValue(v.multiplier);
            RoadRageEngineManager.getReel(v.reel).getSymbol(v.row)?.onSticky();
        })

        RoadRageEngineManager.RSAll((rc,sym) => { 
            sym.isCar && !sym.state.equal("Sticky") ? sym.changeState({sym:"W",state:"normal",forceState:true}) : undefined
        });


        if (Object.keys(this.initD.fsRestoreData).length){
            this.initD.fsRestoreData.previousEvaluatedArea.forEach((v, reel) => {
                RoadRageEngineManager.getReel(reel).AllWindowSymbols.forEach(sym => {
                    if(sym.isMystery){
                        sym.changeState({ forceState: true, state: this.initD.fsRestoreData.previousEvaluatedArea[reel][sym.posID[0]][3], duration: 0, sym: "M" })
                    } 
                })
            })
        }
        this.timeline.to(this, { duration: 0.25 });
    }

    createPresentation():void{
        this.showCarBoxes();
        FsLeftBox.instance.alpha = 0;
        this.PresentationState.setInactive()
    }

    addExtraForStart(reel: RoadRageEngineController): void {
        reel.setGraphAlpha(0.25,reel.startDuration);
    }
    
    done():void{
        //Speedster.pauseGame();
    }
}